import styled from "styled-components/macro";

export const Container = styled.div(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "10px",

  "&.link": {
    paddingTop: "24px",
    a: {
      textAlign: "left",
    },
  },
}));
